import { render, staticRenderFns } from "./DrugComponent.vue?vue&type=template&id=00dc4cd0&scoped=true"
import script from "./DrugComponent.vue?vue&type=script&lang=js"
export * from "./DrugComponent.vue?vue&type=script&lang=js"
import style0 from "./DrugComponent.vue?vue&type=style&index=0&id=00dc4cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc4cd0",
  null
  
)

export default component.exports